<div [ngStyle]="alignStyle">
  <svg [ngStyle]="contentStyle" preserveAspectRatio="none" [data-jdenticon-value]="userDetail.fullName"></svg>
</div>
